export const DS_LIGHT_BOX_WIDGET_SELECTOR = [
  "button",
  "checkbox",
  "combobox",
  "grid",
  "gridcell",
  "listbox",
  "menu",
  "menubar",
  "menuitem",
  "menuitemcheckbox",
  "menuitemradio",
  "radio",
  "radiogroup",
  "scrollbar",
  "searchbox",
  "slider",
  "spinbutton",
  "switch",
  "tab",
  "tablist",
  "textbox",
  "toolbar",
  "tree",
  "treegrid",
  "treeitem",
]
  .map(role => `[role~="${role}"]`)
  .join(", ");

export const DS_LIGHT_BOX_KEYBOARD_EXCLUSION_SELECTOR = `video, audio, input, textarea, select, [contenteditable], ${DS_LIGHT_BOX_WIDGET_SELECTOR}`;

export const DS_LIGHT_BOX_POINTER_EXCLUSION_SELECTOR = `button, a, input, textarea, select, video, audio, [contenteditable], ${DS_LIGHT_BOX_WIDGET_SELECTOR}`;
